
const LoadingSpinner = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'loading loading-spinner loading-sm',
    medium: 'loading loading-spinner loading-md',
    large: 'loading loading-spinner loading-lg'
  };

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <span className={sizeClasses[size]}></span>
    </div>
  );
};

export default LoadingSpinner;